export default __webpack_public_path__ + "static/media/logo_other.63df8fe6.png";